<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       empty-text="데이타가 없습니다">
        <el-table-column
      align="center" label="리턴">
      <template slot-scope="scope">
        
          <el-button type="primary" size="mini" plain @click="todayRound(scope.$index, scope)" :disabled="scope.row.btn1">리턴</el-button>
        
        
      </template>
      </el-table-column>
         <el-table-column
        
        label="회차" prop="todayRound" align="center">
        
      </el-table-column> 
       <el-table-column
        
        label="불러오기"  align="center" width="150" class="d-flex  align-items-center">
        <template slot-scope="scope">
          
        <el-button type="success" icon="el-icon-upload" class="mr-2" :disabled="scope.row.btn2" style="padding:0 15px;line-height:28px;height:28px;" @click="cloud(scope)"></el-button>
       <el-select v-model="scope.row.page" size="mini" style="width: 60px;">
                                  <el-option
                                  v-for="item in numOpt"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                                </el-select>

       

      </template>
        
      </el-table-column> 
   
       <el-table-column
        
        label="시간" prop="time" align="center" width="110">
         <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.time">
          </el-input>
          </template>
      </el-table-column> 
     
      <el-table-column
        
        label="슷자" prop="number" align="center" width="170">
         <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.number"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="합" prop="numberSum" align="center">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.numberSum"></el-input>
          </template>
      </el-table-column> 
        <el-table-column
        
        label="파워볼" prop="powerball" align="center">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.powerball"></el-input>
          </template>
      </el-table-column> 
        <el-table-column
        
        label="파홀짝" prop="powerballOddEven" align="center">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.powerballOddEven"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="일홀짝" prop="numberOddEven" align="center">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.numberOddEven"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="파언오" prop="powerballUnderOver" align="center">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.powerballUnderOver"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="일언오" prop="numberUnderOver" align="center">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.numberUnderOver"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="대중소" prop="numberPeriod" align="center">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.numberPeriod"></el-input>
          </template>
      </el-table-column>
       <el-table-column
      align="center" width="150" label="수정">
      <template slot-scope="scope">
        
          <el-button type="primary" size="mini" @click="edit(scope)" :disabled="scope.row.btn3">등록</el-button>
        
        
      </template>
      </el-table-column>
       <el-table-column
        
        label="배팅금" prop="total" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.total)}}</template>
      </el-table-column>
      
      <el-table-column
        
        label="내역" prop="gubun" align="center"  width="150">
         <template slot-scope="scope">
        
         <div v-for="(item,index) in scope.row.gubun" :key="index">
          {{index}}:{{formatMoney(item)}}
         </div>
        
        
      </template>
      </el-table-column>

      <el-table-column
        
        label="적중금" prop="total_e" align="center" >
         <template slot-scope="scope">{{ formatMoney(scope.row.total_e)}}</template>
        
      </el-table-column>
      </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
        
				
</div>
 </template>

 <script>
 
 
    export default {
    
    	data(){
    		return{
          domain:window.sessionStorage.getItem('domain'),
    		disabled:false,
         numOpt: [{
              label: '1',
              value: '1',
             
            },{
              label: '2',
               value: '2',
             
            }, 
            {
              label: '3',
               value: '3',
             
            },
            {
              label: '4',
               value: '4',
             
            },{
              label: '5',
               value: '5',
             
            },
             
            ],
            num:'1',
          optvalue:[
           {
              label:'1',
              value:'1'
            },
             {
              label:'2',
              value:'2'
            },
             {
              label:'3',
              value:'3'
            },


          ],
          valuenum:'1',

		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 tableData: [],
			       currentPage:1,

    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
   
    	methods:{
          edit(e){
              this.$confirm('등록하시겠습니까?', '알림', {
              confirmButtonText: '확인',
              cancelButtonText: '취소',
              type: 'warning'
            }).then(() => {
            
                       let token=window.sessionStorage.getItem('user');
                       e.row.btn3 = true
                       this.$axios({
                        method:'post',
                        url:this.domain+'/admin/powerball_result_up_bg',
                        data:{
                            time:e.row.time,
                            number:e.row.number,
                            numberSum:e.row.numberSum,
                            powerball:e.row.powerball,
                            powerballOddEven:e.row.powerballOddEven,
                            powerballUnderOver:e.row.powerballUnderOver,
                            numberOddEven:e.row.numberOddEven,
                            numberUnderOver:e.row.numberUnderOver,
                            numberPeriod:e.row.numberPeriod,
                            id:e.row.id,
                        
                        
                           
                          },   
                        'Accept': 'application/json',
                        headers: { 'Authorization': 'Bearer ' + token },
                        
                     
                  }).then((response) =>{ 

                    e.row.btn3 = false

                   if(response.data.code==200){
                       
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   

                    }else{
                      this.$message.error(response.data.msg)
                    }
                    //this.disabled = false
                    this.getList()
                   
                  }).catch((error) =>{
                      console.log(error)
                      e.row.btn3 = false
                  })
       

            }).catch(() => {
            this.$message({
              type: 'info',
              message: '취소됨'
            });          
        });
          //this.disabled = true
         
         
            
         
        },
    		cloud(e){
          let token=window.sessionStorage.getItem('user');
           e.row.btn2 = true
           this.$axios({
                      method:'get',
                      url:this.domain+'/admin/get_power_json_bg?page='+e.row.page+'&num='+e.row.todayRound,
                      
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                    //console.log('response',response);

                     e.row.btn2 = false

                   if(response.data.code==200){
                       
                        //console.log(response.data.data.data);
                        let dd=response.data.data.data;
                        e.row.number=dd.number;
                        e.row.numberOddEven=dd.numberOddEven;
                        e.row.numberSum=dd.numberSum;
                        e.row.numberUnderOver=dd.numberUnderOver;
                        e.row.powerball=dd.powerball;
                        e.row.powerballOddEven=dd.powerballOddEven;
                        e.row.powerballUnderOver=dd.powerballUnderOver;
                        let g=dd.numberPeriod.split(' ');
                        e.row.numberPeriod=g[0];

                        this.$message.success('success')
                      
                    }else{

                        this.$message.error(response.data.msg)
                    }
                  
                   
                  }).catch((error) =>{
                       console.log(error)
                       e.row.btn2 = false    
                  })
         
            
         
        },
           
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       todayRound(index,e){
         this.$confirm('리턴하시겠습니까', '알림', {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          type: 'warning'
        }).then(() => {
        
          e.row.btn1 = true
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                      method:'post',
                      url:this.domain+'/admin/powerball_res_cancel_bg?id='+e.row.id,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },  
                     
                  }).then((response) =>{ 
                   e.row.btn1 = false
                   if(response.data.code==200){
                       
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                    }else{
                      this.$message.error(response.data.msg)
                    }
                    this.getList()
                   
                  }).catch((error) =>{
                      console.log(error)
                       e.row.btn1 = false
                  })
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: '취소됨'
          });          
        });

         //return;
         
         
            
         
        },
    		getList(){

    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/powerball_result_bg?page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     //console.log('tableData=',response.data.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
               
            })
    		},
    	
    
    		
    	}
  }
</script>

 <style scoped>


</style>


// WEBPACK FOOTER //
// src/views/powerball_bg/list.vue